// Angular
import { Component, DestroyRef, inject, OnInit, signal, viewChild } from '@angular/core';
import { RouterLink, Router, ActivatedRoute } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

// Angular Material
import { MatTabsModule } from '@angular/material/tabs';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

// Components
import { IntegrationTableComponent } from '../integration-table/integration-table.component';

// Constants
import { INTEGRATION_CATEGORY_LIST, API_URL_PATHS } from '@components/integration/defs';
import { Action } from '@constants/enum';

@Component({
  selector: 'app-integration-tabs',
  imports: [
    MatTabsModule,
    MatCardModule,
    MatFormFieldModule,
    MatSidenavModule,
    MatInputModule,
    IntegrationTableComponent,
    MatButtonModule,
    RouterLink,
  ],
  templateUrl: './integration-tabs.component.html',
  styleUrl: './integration-tabs.component.scss',
})
export class IntegrationTabsComponent implements OnInit {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private destroyRef = inject(DestroyRef);

  readonly selectedIndex = signal(0);
  readonly table = viewChild(IntegrationTableComponent);
  readonly searchTerm = signal('');

  readonly integrationCategoryList = Object.values(INTEGRATION_CATEGORY_LIST);
  readonly apiUrlPaths = API_URL_PATHS;
  readonly action = Action;

  ngOnInit() {
    this.route.params.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      const index = this.apiUrlPaths.indexOf(params['integrationType']);
      this.selectedIndex.set(index >= 0 ? index : 0);
    });
  }

  onTabChange(index: number) {
    this.router.navigate(['/integrations', this.apiUrlPaths[index]]);
  }

  exportData() {
    this.table()?.exportData();
  }

  search(value: string) {
    this.searchTerm.set(value);
  }
}
